import { render, staticRenderFns } from "./MicroCard.vue?vue&type=template&id=60ce8fb2"
import script from "./MicroCard.vue?vue&type=script&lang=js"
export * from "./MicroCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports